export const header = {
  name: "Christian Arneson",
  email: "carneson39@gmail.com",
  phone: "(720) 289-9754",
  location: "Golden, CO",
  githubURL: "https://github.com/christiano39",
  linkedInURL: "https://www.linkedin.com/in/christianthedev/",
};

export const skills = [
  "React",
  "Redux",
  "Node.js",
  "Express.js",
  "JavaScript",
  "Python",
  "HTML",
  "CSS",
];

export const resumeSections = [
  {
    title: "Experience and Leadership",
    sections: [
      {
        title: "Lambda School",
        location: "Online",
        secondaryTitle: "Lambda Leadership Program",
        dateOrLink: "July 2020 - Present",
        bullets: [
          "Met with and mentored students who were not as far in the curriculum",
          "Held daily 1 on 1 code review sessions, and helped with debugging, answering questions, etc",
          "Utilized communication and problem solving skills to guide students through problems",
        ],
      },
      {
        title: "Lambda School",
        location: "Online",
        secondaryTitle: "Build Weeks",
        dateOrLink: "May 2020 - Aug 2020",
        bullets: [
          "Worked as part of several cross-functional teams in order to create apps based on given specifications",
          "Communicated with team members in order to smoothly provide continuous integration",
          "Built full stack applications using React and Node.js",
          "Wrote comprehensive test suites, including unit tests, integration tests and end to end tests",
        ],
      },
    ],
  },
  {
    title: "Projects",
    sections: [
      {
        title: "My Weather",
        dateOrLink: "https://github.com/christiano39/weather",
        description:
          "An app designed to display the weather conditions at the user’s location",
        skills: ["React", "MaterialUI", "CSS", "HTML"],
        bullets: [
          "Utilizes user geolocation in order to fetch weather conditions",
          "Users can add any city’s weather conditions provided that the city is supported by the OpenWeather API",
          "Leverages local storage in order to preserve the user’s list of cities on the client",
        ],
      },
      {
        title: "Crypto Tracker",
        dateOrLink: "https://github.com/christiano39/dark-mode",
        description:
          "An app that charts prices of crypto-currencies and provides additional info about each currency",
        skills: ["React", "SASS", "HTML"],
        bullets: [
          "Fetches currency data using CoinGecko API",
          "Currency data is charted using Recharts library along with Moment",
          "Users can search for currencies or view a list of popular currencies",
        ],
      },
    ],
  },
  {
    title: "Education",
    sections: [
      {
        title: "Lambda School",
        location: "Online",
        secondaryTitle: "Full Stack Web Development & Computer Science",
        dateOrLink: "May 2020 - Present",
        bullets: [
          "Lambda School is a 9+ month accelerated program with an immersive (full-time, 40+ hours/week) hands-on curriculum with a focus on computer science, software engineering, and web development.",
        ],
      },
      {
        title: "University of Nebraska",
        location: "Lincoln, NE",
        secondaryTitle: "Computer Science",
        dateOrLink: "Aug 2014 - May 2016",
        bullets: [
          "Completed 2 years of a 4 year computer science degree. Degree not obtained.",
        ],
      },
    ],
  },
];
